
/**
 * @file VariantObjArrayFieldContainer.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Apr 08, 2022 17:57
 */
import PropTypes from 'prop-types';

import VariantObjArrayField from './VariantObjArrayField';

function VariantObjArrayFieldContainer(props) {
    const {
        annotationType,
        fieldSchema,
        biocurations,
        variantObjArray,
        handleBlur,
        handleAdd,
        handleDelete,
        handleGDotLookup,
    } = props;

    return <VariantObjArrayField
        annotationType={annotationType}
        fieldSchema={fieldSchema}
        biocurations={biocurations}
        variantObjArray={variantObjArray}
        handleAdd={handleAdd}
        handleBlur={handleBlur}
        handleDelete={handleDelete}
        handleGDotLookup={handleGDotLookup}
    />
}

VariantObjArrayFieldContainer.propTypes = {
    annotationType: PropTypes.string.isRequired,
    fieldSchema: PropTypes.array.isRequired,
    biocurations: PropTypes.object.isRequired,
    variantObjArray: PropTypes.array.isRequired,
    handleBlur: PropTypes.func.isRequired,
    handleAdd: PropTypes.func.isRequired,
    handleDelete: PropTypes.func.isRequired,
    handleGDotLookup: PropTypes.func.isRequired,
};

export default VariantObjArrayFieldContainer;